import { definePath } from '../../router/definePath';

export const SubscriptionPaths = {
  withdrawal: definePath('public', { de: '/vertrag-widerrufen', en: '/withdrawal' }),
  cancellation: definePath('public', { de: '/kuendigung', en: '/cancellation' }),
} as const;
